// ReforcoDialog.jsx
import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import MoneyTextField from "../../Inputs/MoneyTextField";

export default function ReinforcementDialog({ open, onClose, onConfirm }) {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  const handleConfirm = () => {
    onConfirm({
      amount: parseFloat(amount) * 100,
      description,
      transactionType: 1,
      onClose,
    });
    setAmount("");
  };

  return (
    <Dialog open={open} onClose={onClose} sx={{ zIndex: 999999 }}>
      <DialogTitle>Reforço</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <MoneyTextField
            label="Digite o valor do Reforço"
            fullWidth
            value={amount}
            setValue={(val) => setAmount(val)}
          />

          <TextField
            label="Motivo"
            fullWidth
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
